import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
function ServiceDetailsWrapper() {
  const { serviceName } = useParams();
  const serviceData = {
 "web-development": {
  title: "Website Development",
  desc: "We design and develop high-performance websites that are fast, responsive, and built to convert. Every website we create is tailored to your business goals, ensuring a balance between visual appeal and functionality. From landing pages to complex business platforms, we focus on delivering seamless user experiences that engage visitors and drive meaningful actions.\n\nOur development approach prioritizes clean architecture, scalability, and performance optimization. We use modern technologies to ensure your website loads quickly, works flawlessly across all devices, and is easy to maintain. Whether you need a brand-new website or want to upgrade an existing one, we deliver solutions that grow with your business.\n\nBeyond development, we also ensure your website is optimized for search engines and structured for long-term success. Our goal is not just to build a website, but to create a powerful digital asset that supports your business growth."
},

"app-development": {
  title: "Application Development",
  desc: "We build powerful and scalable mobile and web applications designed to deliver seamless user experiences. Our applications are tailored to meet your specific business requirements, whether it's a customer-facing product or an internal operational tool. We focus on intuitive interfaces, smooth performance, and reliable functionality to ensure users stay engaged.\n\nOur development process combines strong backend architecture with modern frontend technologies, ensuring your application is fast, secure, and easy to scale. From MVPs for startups to full-scale enterprise applications, we create solutions that are built for long-term growth and adaptability.\n\nWe also provide continuous support and optimization after deployment, ensuring your application evolves with your business needs. Our goal is to build products that not only function well but also deliver real value to your users and business."
},

"ai-development": {
  title: "AI Development",
  desc: "We develop intelligent AI-powered solutions that help businesses automate processes, analyze data, and make smarter decisions. From chatbots and recommendation systems to custom AI tools, we integrate advanced technologies to solve real-world business challenges and improve operational efficiency.\n\nOur approach focuses on building practical AI solutions that are easy to integrate into your existing systems. We design workflows that reduce manual effort, improve accuracy, and enhance user experiences. Whether it's automating customer interactions or building intelligent data systems, we ensure measurable impact.\n\nBy leveraging machine learning and automation, we help businesses unlock new opportunities and stay competitive in a rapidly evolving digital landscape. Our AI solutions are designed to be scalable, reliable, and aligned with your long-term goals."
},

"game-development": {
  title: "Game Development",
  desc: "We create engaging and high-quality games that deliver immersive experiences across multiple platforms. From concept design to final deployment, we focus on gameplay mechanics, performance optimization, and visual storytelling to bring your ideas to life.\n\nOur team works on everything from casual mobile games to advanced 3D and interactive experiences. We ensure smooth performance, intuitive controls, and engaging user journeys that keep players coming back. Each game is built with attention to detail and a strong focus on user engagement.\n\nWhether you are building a gaming product, educational experience, or interactive application, we combine creativity and technical expertise to deliver results that stand out in the market."
},

"ar-vr": {
  title: "AR/VR Development",
  desc: "We develop immersive augmented and virtual reality experiences that transform how users interact with digital environments. Our solutions are designed to create engaging and interactive experiences for industries such as education, training, marketing, and product visualization.\n\nFrom AR applications that enhance real-world interactions to fully immersive VR simulations, we focus on delivering realistic and high-performance experiences. We ensure smooth performance, intuitive navigation, and visually compelling environments.\n\nOur AR/VR solutions help businesses innovate, improve user engagement, and create unique digital experiences that leave a lasting impact."
},

"graphics": {
  title: "Graphic Designing",
  desc: "We create visually compelling designs that strengthen your brand identity and communicate your message effectively. From logo design and branding to UI/UX and marketing creatives, our designs are crafted to be modern, engaging, and aligned with your business goals.\n\nOur design process focuses on clarity, consistency, and user engagement. We ensure that every visual element reflects your brand personality while maintaining a professional and polished look. Whether it's digital assets or product interfaces, we design with purpose.\n\nBy combining creativity with strategy, we help businesses stand out and create strong visual connections with their audience."
},

"saas": {
  title: "SaaS Development",
  desc: "We build scalable and secure SaaS platforms designed to support long-term business growth. Our solutions include multi-user systems, subscription-based models, dashboards, and cloud-based infrastructure tailored to your specific needs.\n\nWe focus on creating reliable, high-performance platforms with intuitive user interfaces and strong backend architecture. Our SaaS solutions are built for scalability, ensuring they can handle increasing users and data without compromising performance.\n\nFrom concept to deployment and beyond, we provide end-to-end support to help you launch and grow your SaaS product successfully. Our goal is to create systems that drive recurring revenue and deliver continuous value."
}
};
const service = serviceData[serviceName];
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      <section className="service-details sec-mar">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-8 col-xl-8 or2">
              <div className="signle-service-details">
                <h3>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/icons/service-details-icon.svg"
                    }
                    alt="images"
                  />
                  {service?.title || "Service"}
                </h3>
                
                <p>{service?.desc}</p>
                
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 or1">
              {/* <div className="sidebar-search">
                <form
                  onSubmit={(e) => e.preventDefault()}
                  action="#"
                  method="post"
                >
                  <input
                    type="search"
                    name="search"
                    placeholder="Search Here"
                  />
                  <button type="submit">
                    <i className="bi bi-search" />
                  </button>
                </form>
              </div> */}
              <div className="sidebar-widget">
                <h4>Services</h4>
                <ul className="service-list">
                  <li>
                    <Link onClick={scrollTop}to="/service/web-development">
                     
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                      Web Development 
                      </Link>
                  </li>
                  <li>
                      <Link onClick={scrollTop}to="/service/app-development">
                   
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                      Apps Development 
                </Link>
                  </li>
                  <li>
                    <Link onClick={scrollTop}to="/service/ai-development">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                      AI Development
                    </Link>
                  </li>
                  <li>
                    <Link onClick={scrollTop}to="/service/game-development">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                      Game Development 
                    </Link>
                  </li>
                  <li>
                  <Link onClick={scrollTop}to="/service/ar-vr">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                      AR/VR Development
                    </Link>
                  </li>
                  <li>
                    <Link onClick={scrollTop}to="/service/graphics">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                      Graphic Design 
                    </Link>
                  </li>
                  <li>
                    <Link onClick={scrollTop}to="/service/saas">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/dash-circle-icon.svg"
                          }
                          alt="images"
                        />
                      </i>
                       SaaS Development 
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="single-service-work-process">
            <h3>How We Work in our services</h3>
            <div className="single-step">
              <div className="row">
                <div className="col-md-8 col-xl-8 or2">
                  <div className="step">
                    <div className="step-count">
                      <span>01</span>
                    </div>
                    <h4>Discovery & Planning</h4>
                    <p>
                         We begin by understanding your business goals, target audience, and project requirements. 
            This helps us define a clear strategy, choose the right technologies, and create a roadmap 
            that ensures efficient execution.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-xl-4 or1">
                  <div className="step-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/step-1.png"}
                      alt="images"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="single-step">
              <div className="row">
                <div className="col-md-4 col-xl-4">
                  <div className="step-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/step-2.jpg"}
                      alt="images"
                    />
                  </div>
                </div>
                <div className="col-md-8 col-xl-8">
                  <div className="step">
                    <div className="step-count">
                      <span>02</span>
                    </div>
                    <h4>Design & Development</h4>
                    <p>
                        Our team designs intuitive user experiences and develops high-performance solutions 
            using modern technologies. We focus on scalability, speed, and clean architecture 
            to ensure your product performs flawlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-step">
              <div className="row">
                <div className="col-md-8 col-xl-8 or2">
                  <div className="step">
                    <div className="step-count">
                      <span>03</span>
                    </div>
                    <h4>Testing, Launch & Support</h4>
                    <p>
                       Before launch, we thoroughly test the product for performance, security, and usability. 
            After deployment, we provide continuous support, updates, and improvements to ensure 
            long-term success.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-xl-4 or1">
                  <div className="step-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/step-3.jpg"}
                      alt="images"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceDetailsWrapper;
